import { VideoMime } from 'lib_ts/enums/files.enums';
import { AwsRegion } from 'lib_ts/enums/s3.enum';
import { StereoVideoType } from 'lib_ts/enums/videos.enums';
import { IStereoVideo } from 'lib_ts/interfaces/i-stereo-video';

export const DUMMY_DATA: IStereoVideo = {
  _id: '6a318f125c17136c5b15f9f4',
  _parent_id: '6a318f0359229078971d13b9',
  type: StereoVideoType.Replay,
  _changed: '2026-06-16T17:59:46.943Z',
  _changedby: 'node-server @ 6.5.0.0',
  _created: '2026-06-16T17:59:46.943Z',
  _createdby: 'node-server @ 6.5.0.0',
  _parent_def: 'session-events',
  _parent_field: 'replay-video',
  height: 480,
  machineID: 'Arc73',
  metadata: {
    video_width: 718,
    video_height: 480,
    n_frames: 95,
    side_idx: 0,
    origin_px: {
      x: 360.3335911185441,
      y: 421.08880149943946,
    },
    pixels_per_foot: {
      x: 59.95745545042727,
      z: 59.95755456488229,
    },
    detection_frames: [
      {
        idx: 14,
        x_px: 842.603997814917,
        y_px: -219.74654535541617,
        r_px: 36.544910179640716,
      },
      {
        idx: 15,
        x_px: 751.6564468109679,
        y_px: -137.3203978944787,
        r_px: 30.812375249500995,
      },
      {
        idx: 16,
        x_px: 685.0742357752756,
        y_px: -75.70046463354821,
        r_px: 25.79640718562874,
      },
      {
        idx: 17,
        x_px: 634.0015599903708,
        y_px: -28.637005587864348,
        r_px: 22.93013972055888,
      },
      {
        idx: 18,
        x_px: 595.1674102356809,
        y_px: 8.844678391255606,
        r_px: 20.780439121756487,
      },
      {
        idx: 19,
        x_px: 562.4470127889972,
        y_px: 39.19840859725336,
        r_px: 17.914171656686626,
      },
      {
        idx: 20,
        x_px: 535.0679556719081,
        y_px: 64.13846824201232,
        r_px: 16.481037924151696,
      },
      {
        idx: 21,
        x_px: 514.1934627753769,
        y_px: 86.68885098444507,
        r_px: 15.764471057884231,
      },
      {
        idx: 22,
        x_px: 495.1767560764701,
        y_px: 104.72427436589125,
        r_px: 14.3313373253493,
      },
      {
        idx: 23,
        x_px: 479.1651505795781,
        y_px: 121.03724184592208,
        r_px: 13.614770459081836,
      },
      {
        idx: 24,
        x_px: 465.15060784193327,
        y_px: 135.42967107798486,
        r_px: 12.89820359281437,
      },
      {
        idx: 25,
        x_px: 454.1622524147262,
        y_px: 147.91139884914517,
        r_px: 12.181636726546905,
      },
      {
        idx: 26,
        x_px: 443.00117896226584,
        y_px: 159.44557634704316,
        r_px: 10.748502994011975,
      },
      {
        idx: 27,
        x_px: 433.5276064844188,
        y_px: 169.90041142621916,
        r_px: 10.748502994011975,
      },
      {
        idx: 28,
        x_px: 426.06442524192335,
        y_px: 179.38779274978978,
        r_px: 10.03193612774451,
      },
      {
        idx: 29,
        x_px: 418.60366313424174,
        y_px: 188.0740479610426,
        r_px: 9.315369261477045,
      },
      {
        idx: 30,
        x_px: 411.66766467065867,
        y_px: 196.23318385650222,
        r_px: 8.59880239520958,
      },
    ],
    plate_px: {
      strike_zone: [
        {
          x_px: 404.59802558650927,
          y_px: 333.74856069463743,
        },
        {
          x_px: 318.6596836321465,
          y_px: 333.77458745052365,
        },
        {
          x_px: 318.70784004683304,
          y_px: 212.0113473954638,
        },
        {
          x_px: 404.71814671735416,
          y_px: 212.0048681684603,
        },
      ],
      ball_crossing: {
        idx: 36,
        x_px: 386.4182758961915,
        y_px: 228.71765723955235,
        r_px: 8.59880239520958,
      },
    },
    pitch_curve: [
      {
        idx: 14,
        x_px: 842.222775817837,
        y_px: -221.86210261027264,
      },
      {
        idx: 15,
        x_px: 751.604310055672,
        y_px: -139.12703563930046,
      },
      {
        idx: 16,
        x_px: 685.1656261254251,
        y_px: -77.95732194875926,
      },
      {
        idx: 17,
        x_px: 634.4811537622089,
        y_px: -30.825075596877536,
      },
      {
        idx: 18,
        x_px: 594.6197153846772,
        y_px: 6.671479753322559,
      },
      {
        idx: 19,
        x_px: 562.5091946511966,
        y_px: 37.27278756729009,
      },
      {
        idx: 20,
        x_px: 536.1387798194322,
        y_px: 62.77155556008739,
      },
      {
        idx: 21,
        x_px: 514.1361236571043,
        y_px: 84.39084138605921,
      },
      {
        idx: 22,
        x_px: 495.5339607293144,
        y_px: 102.99238270726428,
      },
      {
        idx: 23,
        x_px: 479.630674623515,
        y_px: 119.20111235860621,
      },
      {
        idx: 24,
        x_px: 465.9058013324956,
        y_px: 133.4804290008797,
      },
      {
        idx: 25,
        x_px: 453.9641840222056,
        y_px: 146.18217536279948,
      },
      {
        idx: 26,
        x_px: 443.50088035176236,
        y_px: 157.57783796588697,
      },
      {
        idx: 27,
        x_px: 434.2772012708051,
        y_px: 167.87981336702137,
      },
      {
        idx: 28,
        x_px: 426.10297651275323,
        y_px: 177.2573882028699,
      },
      {
        idx: 29,
        x_px: 418.8251466032021,
        y_px: 185.84681355947558,
      },
      {
        idx: 30,
        x_px: 412.3194024598874,
        y_px: 193.75866019617618,
      },
      {
        idx: 31,
        x_px: 406.48324932315387,
        y_px: 201.08417613137053,
      },
      {
        idx: 32,
        x_px: 401.23172922797465,
        y_px: 207.89897465046846,
      },
      {
        idx: 33,
        x_px: 396.4936925720452,
        y_px: 214.26641443222684,
      },
      {
        idx: 34,
        x_px: 392.20934324908865,
        y_px: 220.23966152352077,
      },
      {
        idx: 35,
        x_px: 388.32772965808897,
        y_px: 225.8641069505662,
      },
    ],
  },
  mime: VideoMime.MP4,
  path: 'machine-videos/Arc73/StereoDetector/2026-06-12/6a2c85b5b723f2c389f23a17/replay_video_6a2c85b5b723f2c389f23a17_1781302713.mp4',
  region: AwsRegion.CA,
  width: 718,
};
